import { styled } from 'styled-components';

import { IconAcademicCap } from '../../../components/Header/Icons';

const StyledProgressBar = styled.div`
  width: ${({ width }) => `${width}px`};
  height: 8px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid ${({ success }) => (success ? '#6BAE46' : '#FFC500')};
  border-radius: 10px;
  z-index: -1;

  &:after {
    content: '';
    width: ${({ percentage }) => `${percentage}%`};
    height: 100%;
    background: ${({ success }) => (success ? '#6BAE46' : '#FFC500')};
    display: block;
    border-radius: ${({ percentage }) =>
      percentage < 95 ? '10px 0 0 10px' : '10px'};
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  height: 24px;
`;

const ProgressBar = ({
  width = 41,
  percentage = 80,
  isTargetCompleted = true,
  ...rest
}) => (
  <Container {...rest}>
    <IconAcademicCap />
    <StyledProgressBar
      width={width}
      percentage={percentage}
      success={isTargetCompleted}
    />
  </Container>
);

export default ProgressBar;
